import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, OnDestroy } from '@angular/core';
import { PresaleTransacationService } from '../../services/presale-transactions.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-latest-purchase',
  standalone: false,
  templateUrl: './latest-purchase.component.html',
  styleUrl: './latest-purchase.component.scss',
})
export class LatestPurchaseComponent implements OnDestroy {
  private refreshTimer: any;

  constructor(
    private TransactionService: PresaleTransacationService,
    @Inject(PLATFORM_ID) private platform_id: Object,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platform_id)) {
      this.getTokenTransactions()
      // start a timer to refresh relative times every 15s (only in browser)
      this.refreshTimer = setInterval(() => {
        // trigger change detection so template updates relative time strings
        try { this.cdr.detectChanges(); } catch (e) { /* noop */ }
      }, 15000);
    }
  }

  async getTokenTransactions() {
    (await this.TransactionService.getTransactions()).subscribe((items: any) => {
      console.log({items});
      this.TransactionService.setAllTransaction(items?.result || []);
      this.TransactionService.startListner()      
    });
  }

  // Updated to fetch, sort by newest, and grab the latest 3
  get latestTransactions() {
    const txs = this.TransactionService.transactions || [];
    
    // Clone the array using slice() so we don't mutate the original data
    // Sort by timestamp (newest first)
    return txs.slice().sort((a: any, b: any) => {
      const timeA = typeof a.timestamp === 'number' ? a.timestamp : Date.parse(a.timestamp || 0);
      const timeB = typeof b.timestamp === 'number' ? b.timestamp : Date.parse(b.timestamp || 0);
      return timeB - timeA;
    }).slice(0, 3); // Take only the latest 3
  }

  // trackBy added to prevent performance issues / DOM thrashing during change detection
  trackByTx(index: number, item: any) {
    return item.timestamp || index; 
  }

  getRelativeTime(timestamp?: string | number) {
    if (!timestamp) return '';
    let time: number;
    // Accept either numeric epoch (seconds or ms) or ISO string
    if (typeof timestamp === 'number') {
      time = timestamp;
    } else if (/^\d+$/.test(String(timestamp))) {
      // numeric string - decide seconds vs ms
      const num = Number(timestamp);
      time = num > 1e12 ? num : num * 1000;
    } else {
      const parsed = Date.parse(timestamp);
      time = isNaN(parsed) ? Date.now() : parsed;
    }

    const diff = Date.now() - time;
    if (diff < 0) return 'just now';

    const seconds = Math.floor(diff / 1000);
    if (seconds < 10) return 'just now';
    if (seconds < 60) return `${seconds}s ago`;

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;

    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  }

  ngOnDestroy(): void {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  }

}